import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { MatDialog } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var ArquitectoComponent = /** @class */ (function () {
    function ArquitectoComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = []; // = [];
        this.selectedArq = null;
        this.matcher = new FormService();
        this.regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        this.rut_arq = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        this.mail_arq = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        });
        if (!JSON.parse(localStorage.getItem("arquitectos"))) {
            localStorage.setItem("arquitectos", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("arquitectos"));
        }
        this.invalidRut = true;
        this.arquitecto = {
            rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
            direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', profesion: '', recordId: ''
        };
    }
    ArquitectoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    ArquitectoComponent.prototype._filter = function (value) {
        var filterValue = ('' + value).toLowerCase();
        return this.options.filter(function (option) { return ('' + option).toLowerCase().includes(filterValue); });
    };
    ArquitectoComponent.prototype.get_arquitecto = function (rut) {
        var _this = this;
        window.scroll(0, 0);
        this.spinner.show();
        this.cleanData();
        this._userService.getArquitecto(rut).subscribe(function (response) {
            if (response.message) {
                _this.arquitecto.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
                //console.log("get arquitecto response message",id);
            }
            else {
                //console.log("get arquitecto else",id);
                _this.arquitecto.rut = response.rut ? response.rut : '';
                _this.arquitecto.nombre = response.nombre ? response.nombre : '';
                _this.arquitecto.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.arquitecto.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.arquitecto.direccion = response.direccion ? response.direccion : '';
                _this.arquitecto.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.arquitecto.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.arquitecto.comuna = response.comuna ? response.comuna : '';
                _this.arquitecto.fono = response.fono ? response.fono : '';
                _this.arquitecto.fax = response.fax ? response.fax : '';
                _this.arquitecto.mail = response.mail ? response.mail : '';
                _this.arquitecto.patente = response.patente ? response.patente : '';
                _this.arquitecto.profesion = response.profesion ? response.profesion : '';
                /*console.log("this.arquitecto.patente: " + this.arquitecto.patente + "response.patente: " + response.patente);
                console.log("this.arquitecto.mail: " + this.arquitecto.mail)
                console.log("this.arquitecto: " + this.arquitecto);*/
                _this.arquitecto.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    ArquitectoComponent.prototype.cleanData = function () {
        this.arquitecto = {
            rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
            direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', profesion: '', recordId: ''
        };
        this.rut_arq.reset();
    };
    ArquitectoComponent.prototype.update_arquitecto = function (rut, id) {
        this.get_arquitecto(rut);
        this.selectedArq = id;
    };
    ArquitectoComponent.prototype.saveArquitecto = function () {
        var _this = this;
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.arquitecto.rut == this.rows[x].rut) {
                this.delete_arquitecto(x);
            }
        }
        //elimina fila cuando la editan
        if (this.selectedArq != null) {
            this.delete_arquitecto(this.selectedArq);
            this.selectedArq = null;
        }
        this.spinner.show();
        //console.log("this.arquitecto.rut", this.arquitecto.rut);
        this._userService.saveArquitecto(this.arquitecto).subscribe(function (response) {
            _this.spinner.hide();
            //console.log("save response", response)
            if (response.update || response.save) {
                //console.log("this.arquitecto.rut", this.arquitecto.rut);
                $("#arq_modal").modal("hide");
                _this.actualRow = localStorage.getItem("arquitectos");
                _this.rows = JSON.parse(_this.actualRow);
                //console.log("this.arquitecto.pantente", this.arquitecto.patente);
                _this.rows = _this.rows.concat({
                    rut: _this.arquitecto.rut,
                    nombre: _this.arquitecto.nombre,
                    apellido_mat: _this.arquitecto.apellido_mat,
                    apellido_pat: _this.arquitecto.apellido_pat,
                    direccion: _this.arquitecto.direccion,
                    direccion_num: _this.arquitecto.direccion_num,
                    direccion_complemento: _this.arquitecto.direccion_complemento,
                    comuna: _this.arquitecto.comuna,
                    fono: _this.arquitecto.fono,
                    fax: _this.arquitecto.fax,
                    mail: _this.arquitecto.mail,
                    patente: _this.arquitecto.patente,
                    profesion: _this.arquitecto.profesion
                });
                localStorage.setItem("arquitectos", JSON.stringify(_this.rows));
                _this.arquitecto = {
                    rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
                    direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', profesion: '', recordId: ''
                };
                _this.rut_arq.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    ArquitectoComponent.prototype.delete_arquitecto = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("arquitectos", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('arquitectos'));
            }
        }
    };
    ArquitectoComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return ArquitectoComponent;
}());
export { ArquitectoComponent };
